var map = {
	"./active-btn.webp": 2524,
	"./angbao-bonus-cny.webp": 2525,
	"./angbao-bonus-dewali.webp": 2526,
	"./angbao-bonus-mooncake.webp": 2527,
	"./angbao-bonus-raya.webp": 2528,
	"./angbao-bonus-thaipusam.webp": 2529,
	"./angbao-bonus.webp": 2530,
	"./anni-lucky-draw.webp": 2531,
	"./cny-angbao-bonus.webp": 2532,
	"./cny-lucky-draw.webp": 2533,
	"./cny-promo.webp": 2534,
	"./dewali-promo.webp": 2535,
	"./dongzhi-angbao-bonus.webp": 2536,
	"./fifa-prediction.webp": 2537,
	"./fifa-qna.webp": 2538,
	"./uefa-predic.webp": 2539,
	"./welcome-cny-bonus.webp": 2540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2523;